module.exports = __webpack_public_path__ + "static/media/npr.044887f5.png";